var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.888,
    height: 14.167,
    viewBox: "0 0 18.888 14.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chart-bar",
    "data-name": "Icon awesome-chart-bar",
    d: "M480.3,4048.128H463.18a1.182,1.182,0,0,1-1.181-1.181v-12.4a.591.591,0,0,1,.59-.59h1.181a.591.591,0,0,1,.59.59v11.215H480.3a.591.591,0,0,1,.59.59v1.18A.591.591,0,0,1,480.3,4048.128Zm-1.063-4.722h-1.416a.512.512,0,0,1-.472-.472v-8.5a.512.512,0,0,1,.472-.472h1.416a.512.512,0,0,1,.472.472v8.5A.512.512,0,0,1,479.235,4043.406Zm-3.542,0h-1.416a.512.512,0,0,1-.472-.472v-4.958a.5.5,0,0,1,.472-.471h1.416a.5.5,0,0,1,.472.471v4.958A.512.512,0,0,1,475.694,4043.406Zm-3.542,0h-1.416a.512.512,0,0,1-.472-.472v-7.319a.5.5,0,0,1,.472-.472h1.416a.5.5,0,0,1,.472.472v7.319A.512.512,0,0,1,472.152,4043.406Zm-3.542,0h-1.416a.512.512,0,0,1-.472-.472v-2.6a.512.512,0,0,1,.472-.472h1.416a.5.5,0,0,1,.472.472v2.6A.512.512,0,0,1,468.61,4043.406Z",
    transform: "translate(-462 -4033.962)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.2b352a52b0588dab62f56a7d1c1e436d.svg";
export { ForwardRef as ReactComponent };